import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

type FollowField = 'followerId' | 'followingId';

export function listenToFollowingUserIds(
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void,
  userId: string = getCurrentUserId()
) {
  return listenToFollowUserIds('followerId', 'followingId', userId, onSnapshot, onError);
}

export function listenToFollowerUserIds(
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void,
  userId: string = getCurrentUserId()
) {
  return listenToFollowUserIds('followingId', 'followerId', userId, onSnapshot, onError);
}

export async function getFollowingUserIds(userId: string) {
  return getFollowUserIds('followerId', 'followingId', userId);
}

export async function getFollowerUserIds(userId: string) {
  return getFollowUserIds('followingId', 'followerId', userId);
}

function listenToFollowUserIds(
  queryField: FollowField,
  resultField: FollowField,
  userId: string,
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  const query = getFollowsQuery(queryField, userId);

  return db.onSnapshot(
    query,
    (snapshot) => {
      onSnapshot(new Set(getFollowUserIdsFromSnapshot(snapshot, resultField)));
    },
    onError
  );
}

async function getFollowUserIds(queryField: FollowField, resultField: FollowField, userId: string) {
  const snapshot = await db.getDocs(getFollowsQuery(queryField, userId));
  return getFollowUserIdsFromSnapshot(snapshot, resultField);
}

function getFollowsQuery(field: FollowField, userId: string) {
  return db.query(db.collection(firestore, 'follows'), db.where(field, '==', userId));
}

function getFollowUserIdsFromSnapshot(snapshot: db.QuerySnapshot, field: FollowField) {
  return snapshot.docs
    .map((doc) => getFollowField(doc.data(), field))
    .filter((userId): userId is string => typeof userId === 'string');
}

function getFollowField(data: db.DocumentData, field: FollowField) {
  const value = data[field];
  return typeof value === 'string' ? value : undefined;
}
